/**
 * Podrazumevana konfiguracija AccessibilityPanel komponente.
 * Host prosleđuje delimičan objekat; mergeConfig() spaja sa ovim vrednostima.
 */

/** Tekstovi u UI panela (sr-Cyrl). Za drugi jezik prosledi ceo labels objekat u config. */
export const DEFAULT_LABELS = {
  panelTitle: 'Подешавања приказа',
  openPanel: 'Отвори подешавања приказа',
  closePanel: 'Затвори подешавања приказа',
  close: 'Затвори',
  decrease: 'Смањи',
  increase: 'Повећај',
  toggleOff: 'ИСКЉ',
  toggleOn: 'УКЉ',
  reset: 'Ресетуј на подразумевано',
  resetTitle: 'Ресетуј подешавања',
  tocNav: 'Садржај странице',
  tocToggle: 'Садржај',
  textSizeTitle: 'Величина текста',
  textSizeDesc: 'Подесите величину текста',
  lineSpacingTitle: 'Размак редова',
  lineSpacingDesc: 'Подесите размак између редова текста',
  fontTitle: 'Стил текста',
  fontDesc: 'Промените фонт',
  contrastTitle: 'Контраст',
  contrastDesc: 'Промените боје текста и позадине',
  tocTitle: 'Садржај',
  tocDesc: 'Направите садржај од наслова на страници',
  enhanceTitle: 'Истицање контрола',
  enhanceDesc: 'Истакните везе, дугмад, и поља за унос',
};

/** Koje sekcije panela prikazati. Sve false = prazan modal (ne koristiti). */
export const DEFAULT_FEATURES = {
  textSize: true,
  lineSpacing: true,
  font: true,
  contrast: true,
  toc: true,
  enhanceInputs: true,
};

/** Puna podrazumevana config šema — koristi mergeConfig() pre čitanja. */
export function getDefaultConfig() {
  return {
    storageKey: 'accessibility-panel-prefs',
    classPrefix: 'ap',
    mainContentSelector: '#main-content',
    portalTarget: typeof document !== 'undefined' ? document.body : null,
    showTrigger: true,
    theme: {
      primary: '#253965',
      primaryHover: '#1e2e52',
      textMuted: '#6b7a94',
      fontFamily: 'inherit',
    },
    labels: { ...DEFAULT_LABELS },
    features: { ...DEFAULT_FEATURES },
  };
}
